import React from "react";
import { getClassNameFactory } from "@dcl/ui";
import InlineErrorMessageSVG from "./InlineErrorMessageSVG";

var InlineErrorMessage = function InlineErrorMessage(_ref) {
  var className = _ref.className,
      errorMessage = _ref.errorMessage,
      id = _ref.id;
  var getClassName = getClassNameFactory(InlineErrorMessage.displayName);
  return /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      className: className
    })
  }, /*#__PURE__*/React.createElement("span", {
    role: "presentation",
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(InlineErrorMessageSVG, null)), /*#__PURE__*/React.createElement("span", {
    id: id,
    "aria-live": "assertive",
    className: getClassName({
      descendantName: "message"
    })
  }, errorMessage));
};

InlineErrorMessage.displayName = "InlineErrorMessage";
export default InlineErrorMessage;